import API from '@aws-amplify/api'
import { PREFIX } from './config'
import Cookies from 'js-cookie'
import packageJson from '../../package'
// import store from '../store'
import { sendToSlack } from '../mixins'

export default (functionName, body = {}) => {
    const path = PREFIX + functionName + '/invocations'
    const cookies = Cookies.get()
    body.clientType = 'WEB_VIEW'
    body.clientVersion = packageJson.version

    return API.post('lambda', path, { body }).then(data => {
        if (data.code !== 'OK') {
            // store.dispatch('errors/add', { message: data.errorMsg })
            // store.dispatch('errors/show')
            // store.dispatch('spinner/stop')
            sendToSlack(data, body, cookies)
        }
        return data
    }).catch(err => {
        // store.dispatch('errors/add', err)
        // store.dispatch('errors/show')
        // store.dispatch('spinner/stop')
        sendToSlack(err, body, cookies)
        return err
    })
}
